import Home from "../pages/Home";
import Layout from "./Layout";
import { lazy, Suspense } from "react";
import { createBrowserRouter, Navigate, Outlet } from "react-router";
import PageLoader from "../component/PageLoader";
import Custom404 from "../pages/Custom404";


import { newInterestPages } from "./global";

import RequireAdmin from "../component/RequireAdmin";
import AdminLayout from "../component/AdminLayout";


// Route-level code splitting. Every page below becomes its own chunk that
// downloads only when its route is visited, instead of shipping all ~70
// pages (including the whole admin studio) in the initial bundle.
// Home and Custom404 stay eagerly imported above: Home is the landing
// route where an extra round trip would hurt LCP, and Custom404 is tiny.
const About = lazy(() => import("../pages/About"));
const Technologies = lazy(() => import("../pages/Technologies"));
const Services = lazy(() => import("../pages/Services"));
const CaseStudies = lazy(() => import("../pages/CaseStudies"));
const Career = lazy(() => import("../pages/Career"));
const EZRater = lazy(() => import("../pages/CaseStudyview/EZRater"));
const ThreeLockBox = lazy(() => import("../pages/CaseStudyview/ThreeLockBox"));
const GoalEnvision = lazy(() => import("../pages/CaseStudyview/GoalEnvision"));
const GymChainIntegration = lazy(() => import("../pages/CaseStudyview/GymChainIntegration"));
const AIStyleRecommendation = lazy(() => import("../pages/CaseStudyview/AIStyleRecommendation"));
const AISolutions = lazy(() => import("../pages/AISolutions"));
const AgenticAIDevelopment = lazy(() => import("../pages/AgenticAIDevelopment"));
const RecommendationEngineDevelopment = lazy(() => import("../pages/RecommendationEngineDevelopment"));
const GenerativeAIDevelopment = lazy(() => import("../pages/GenerativeAIDevelopment"));
const CustomSoftwareDevelopment = lazy(() => import("../pages/CustomSoftwareDevelopment"));
const AIIntegrationServices = lazy(() => import("../pages/AIIntegrationServices"));
const LLMIntegrationServices = lazy(() => import("../pages/LLMIntegrationServices"));
const UIUXDesign = lazy(() => import("../pages/UIUXDesign"));
const MobileFirstDesign = lazy(() => import("../pages/MobileFirstDesign"));
const WebDevelopment = lazy(() => import("../pages/WebDevelopment"));
const MobileAppDevelopment = lazy(() => import("../pages/MobileAppDevelopment"));
const EcommerceDevelopment = lazy(() => import("../pages/EcommerceDevelopment"));
const DevOpsServices = lazy(() => import("../pages/DevOpsServices"));
const APIDevelopmentServices = lazy(() => import("../pages/APIDevelopmentServices"));
const DigitalTransformationServices = lazy(() => import("../pages/DigitalTransformationServices"));
const CybersecurityCompliance = lazy(() => import("../pages/CybersecurityCompliance"));
const CloudDevelopmentServices = lazy(() => import("../pages/CloudDevelopmentServices"));
const CloudNativeApplications = lazy(() => import("../pages/CloudNativeApplications"));
const ProductSupportMaintenance = lazy(() => import("../pages/ProductSupportMaintenance"));
const Cledge = lazy(() => import("../pages/Cledge"));
const BoxGenieERP = lazy(() => import("../pages/BoxGenieERP"));
const AgenticHire = lazy(() => import("../pages/AgenticHire"));
const PerformanceOptimization = lazy(() => import("../pages/PerformanceOptimization"));
const NativeCrossPlatformApps = lazy(() => import("../pages/NativeCrossPlatformApps"));
const MobilePerformanceSecurity = lazy(() => import("../pages/MobilePerformanceSecurity"));
const WireframingPrototyping = lazy(() => import("../pages/WireframingPrototyping"));
const UserResearch = lazy(() => import("../pages/UserResearch"));
const CICDPipelines = lazy(() => import("../pages/CICDPipelines"));
const CloudInfrastructureAutomation = lazy(() => import("../pages/CloudInfrastructureAutomation"));
const ServerlessMicroservices = lazy(() => import("../pages/ServerlessMicroservices"));
const CloudArchitectureDesign = lazy(() => import("../pages/CloudArchitectureDesign"));
const CloudConsulting = lazy(() => import("../pages/CloudConsulting"));
const CloudSecurityFacet = lazy(() => import("../pages/CloudSecurityFacet"));
const SecurityAuditsPenTesting = lazy(() => import("../pages/SecurityAuditsPenTesting"));
const ComplianceRegulations = lazy(() => import("../pages/ComplianceRegulations"));
const CybersecurityConsultingServices = lazy(() => import("../pages/CybersecurityConsultingServices"));
const LegacySystemModernization = lazy(() => import("../pages/LegacySystemModernization"));
const DigitalTransformationRoadmap = lazy(() => import("../pages/DigitalTransformationRoadmap"));
const SupportMaintenance = lazy(() => import("../pages/SupportMaintenance"));
const UpdatesBugFixes = lazy(() => import("../pages/UpdatesBugFixes"));
const ITConsulting = lazy(() => import("../pages/ITConsulting"));
const MobileConsulting = lazy(() => import("../pages/MobileConsulting"));
const SoftwareConsulting = lazy(() => import("../pages/SoftwareConsulting"));
const ManagedITServices = lazy(() => import("../pages/ManagedITServices"));
const ITAuditServices = lazy(() => import("../pages/ITAuditServices"));
const EmergingServiceInterest = lazy(() => import("../pages/EmergingServiceInterest"));
const AboutInfoPage = lazy(() => import("../pages/AboutInfoPage"));
const AboutFAQ = lazy(() => import("../pages/AboutFAQ"));
const Contact = lazy(() => import("../pages/Contact"));
const OurCoreTeam = lazy(() => import("../pages/OurCoreTeam"));
const HowWeWork = lazy(() => import("../pages/HowWeWork"));
const Blog = lazy(() => import("../pages/Blog"));
const BlogPost = lazy(() => import("../pages/BlogPost"));
const PreviewPost = lazy(() => import("../pages/PreviewPost"));
const AdminLogin = lazy(() => import("../pages/admin/AdminLogin"));
const AdminDashboard = lazy(() => import("../pages/admin/AdminDashboard"));
const AdminPosts = lazy(() => import("../pages/admin/AdminPosts"));
const AdminCategories = lazy(() => import("../pages/admin/AdminCategories"));
const AdminComments = lazy(() => import("../pages/admin/AdminComments"));
const AdminMedia = lazy(() => import("../pages/admin/AdminMedia"));
const AdminUsers = lazy(() => import("../pages/admin/AdminUsers"));
const AdminPostForm = lazy(() => import("../pages/admin/AdminPostForm"));
const AdminPostDetail = lazy(() => import("../pages/admin/AdminPostDetail"));
const AdminAuditLog = lazy(() => import("../pages/admin/AdminAuditLog"));
const AdminLinkedInQueue = lazy(() => import("../pages/admin/AdminLinkedInQueue"));
const AdminCalendar = lazy(() => import("../pages/admin/AdminCalendar"));
const AdminSeoCenter = lazy(() => import("../pages/admin/AdminSeoCenter"));

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />, // Wrapping all routes with Layout
    children: [
      { path: "/", element: <Home /> },
      { path: "/about", element: <About /> },
      { path: "/technologies", element: <Technologies /> },
      { path: "/services", element: <Services /> },
      { path: "/ai-solutions", element: <AISolutions /> },
      { path: "/case-studies", element: <CaseStudies /> },
      { path: "/case-studies/ezrater", element: <EZRater /> },
      { path: "/case-studies/three-lock-box", element: <ThreeLockBox /> },
      { path: "/case-studies/goal-envision", element: <GoalEnvision /> },
      { path: "/case-studies/gym-chain-integration", element: <GymChainIntegration /> },
      { path: "/career", element: <Career /> },
      { path: "/case-studies/ai-style-recommendation", element: <AIStyleRecommendation /> },
      { path: "/agentic-ai-development", element: <AgenticAIDevelopment /> },
      { path: "/recommendation-engine-development", element: <RecommendationEngineDevelopment /> },
      { path: "/generative-ai-development", element: <GenerativeAIDevelopment /> },
      { path: "/custom-software-development", element: <CustomSoftwareDevelopment /> },
      { path: "/ai-integration-services", element: <AIIntegrationServices /> },
      { path: "/llm-integration-services", element: <LLMIntegrationServices /> },
      { path: "/web-development", element: <WebDevelopment /> },
      { path: "/mobile-app-development", element: <MobileAppDevelopment /> },
      { path: "/ui-ux-design", element: <UIUXDesign /> },
      { path: "/ecommerce-development", element: <EcommerceDevelopment /> },
      { path: "/devops-services", element: <DevOpsServices /> },
      { path: "/api-development", element: <APIDevelopmentServices /> },
      { path: "/digital-transformation", element: <DigitalTransformationServices /> },
      { path: "/cybersecurity-compliance", element: <CybersecurityCompliance /> },
      { path: "/cloud-development", element: <CloudDevelopmentServices /> },
      { path: "/cloud-native-applications", element: <CloudNativeApplications /> },
      { path: "/product-support-maintenance", element: <ProductSupportMaintenance /> },
      { path: "/products/cledge", element: <Cledge /> },
      { path: "/products/kraftigo", element: <BoxGenieERP /> },
      { path: "/products/boxgenie-erp", element: <Navigate to="/products/kraftigo" replace /> },
      { path: "/products/vettingo", element: <AgenticHire /> },
      { path: "/qa-and-testing", element: <EmergingServiceInterest title="QA and Testing" blurb="Planning a QA and testing engagement — manual, automated, or performance testing? Tell us about your project and we'll figure out the right approach together." /> },
      { path: "/product-management", element: <EmergingServiceInterest title="Product Management" blurb="Need product management support for an upcoming build — roadmapping, prioritization, or delivery oversight? Tell us about your project and we'll figure out the right approach together." /> },
      { path: "/blockchain", element: <EmergingServiceInterest title="Blockchain" blurb="Exploring a blockchain-based product or integration? Tell us about your project and we'll figure out the right approach together." /> },
      { path: "/iot", element: <EmergingServiceInterest title="IoT" blurb="Working on a connected-device or IoT platform idea? Tell us about your project and we'll figure out the right approach together." /> },
      { path: "/fintech-consulting", element: <EmergingServiceInterest title="FinTech Consulting" blurb="Building in the FinTech space and need consulting support? Tell us about your project and we'll figure out the right approach together." /> },
      { path: "/big-data", element: <EmergingServiceInterest title="Big Data" blurb="Dealing with large-scale data pipelines or infrastructure challenges? Tell us about your project and we'll figure out the right approach together." /> },
      { path: "/data-analytics", element: <EmergingServiceInterest title="Data Analytics" blurb="Looking to turn your data into actionable insights? Tell us about your project and we'll figure out the right approach together." /> },
      // Long-tail question pages. They own a question intent each — cost,
      // definition, use cases, approach — rather than a service phrase, so
      // they do not compete with the AI service pages for the same query.
      { path: "/agentic-ai-cost", element: <EmergingServiceInterest title="Agentic AI Cost" blurb="Working out what an agentic AI build would cost you? Tell us about your project and we'll scope it honestly." /> },
      { path: "/ai-agents-vs-agentic-ai", element: <EmergingServiceInterest title="AI Agents vs Agentic AI" blurb="Trying to work out which kind of system your problem needs? Tell us about it and we'll tell you straight." /> },
      { path: "/agentic-ai-use-cases", element: <EmergingServiceInterest title="Agentic AI Use Cases" blurb="Wondering whether your process suits an agent? Tell us what it involves and we'll give you an honest read." /> },
      { path: "/rag-vs-fine-tuning", element: <EmergingServiceInterest title="RAG vs Fine-Tuning" blurb="Deciding how to put a model on your own data? Tell us what you hold and how often it changes." /> },
      { path: "/mobile-first-design", element: <MobileFirstDesign /> },
      { path: "/performance-optimization", element: <PerformanceOptimization /> },
      { path: "/native-cross-platform-apps", element: <NativeCrossPlatformApps /> },
      { path: "/mobile-performance-security", element: <MobilePerformanceSecurity /> },
      { path: "/wireframing-prototyping", element: <WireframingPrototyping /> },
      { path: "/user-research", element: <UserResearch /> },
      { path: "/ci-cd-pipelines", element: <CICDPipelines /> },
      { path: "/cloud-infrastructure-automation", element: <CloudInfrastructureAutomation /> },
      { path: "/serverless-microservices", element: <ServerlessMicroservices /> },
      { path: "/cloud-architecture-design", element: <CloudArchitectureDesign /> },
      { path: "/cloud-consulting", element: <CloudConsulting /> },
      { path: "/cloud-security-facet", element: <CloudSecurityFacet /> },
      { path: "/security-audits-pen-testing", element: <SecurityAuditsPenTesting /> },
      { path: "/compliance-regulations", element: <ComplianceRegulations /> },
      { path: "/cybersecurity-consulting-services", element: <CybersecurityConsultingServices /> },
      { path: "/legacy-system-modernization", element: <LegacySystemModernization /> },
      { path: "/digital-transformation-roadmap", element: <DigitalTransformationRoadmap /> },
      { path: "/support-maintenance", element: <SupportMaintenance /> },
      { path: "/updates-bug-fixes", element: <UpdatesBugFixes /> },
      { path: "/it-consulting", element: <ITConsulting /> },
      { path: "/mobile-consulting", element: <MobileConsulting /> },
      { path: "/software-consulting", element: <SoftwareConsulting /> },
      { path: "/managed-it-services", element: <ManagedITServices /> },
      { path: "/it-audit-services", element: <ITAuditServices /> },
      ...newInterestPages.map((p) => ({
        path: p.path,
        element: <EmergingServiceInterest title={p.title} blurb={p.blurb} />,
      })),
      { path: "/our-core-team", element: <OurCoreTeam /> },
      { path: "/how-we-work-and-function", element: <HowWeWork /> },
      {
        path: "/corporate-social-responsibility",
        element: <AboutInfoPage title="Corporate Social Responsibility" body={[
          "We care about doing business responsibly. Reach out if you'd like to learn more about our approach.",
        ]} />,
      },
      { path: "/faq", element: <AboutFAQ /> },
      { path: "/contact", element: <Contact /> },
      { path: "/blog", element: <Blog /> },
      { path: "/blog/:slug", element: <BlogPost /> },
      { path: "/preview/:token", element: <PreviewPost /> },
      { path: "*", element: <Custom404 /> },
    ],
  },
  {
    path: "/admin",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      { path: "login", element: <AdminLogin /> },
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <RequireAdmin><AdminDashboard /></RequireAdmin> },
          { path: "posts", element: <RequireAdmin><AdminPosts /></RequireAdmin> },
          { path: "posts/new", element: <RequireAdmin><AdminPostForm /></RequireAdmin> },
          { path: "posts/:id/edit", element: <RequireAdmin><AdminPostForm /></RequireAdmin> },
          { path: "posts/:id/stats", element: <RequireAdmin><AdminPostDetail /></RequireAdmin> },
          { path: "audit-log", element: <RequireAdmin><AdminAuditLog /></RequireAdmin> },
          { path: "linkedin-queue", element: <RequireAdmin><AdminLinkedInQueue /></RequireAdmin> },
          { path: "calendar", element: <RequireAdmin><AdminCalendar /></RequireAdmin> },
          { path: "seo", element: <RequireAdmin><AdminSeoCenter /></RequireAdmin> },
          { path: "categories", element: <RequireAdmin><AdminCategories /></RequireAdmin> },
          { path: "comments", element: <RequireAdmin><AdminComments /></RequireAdmin> },
          { path: "media", element: <RequireAdmin><AdminMedia /></RequireAdmin> },
          { path: "users", element: <RequireAdmin><AdminUsers /></RequireAdmin> },
        ],
      },
    ],
  },
]);
